export class NetworkError extends Error {
	constructor(
		message = 'Unable to connect to the internet. Please check your connection and try again.',
	) {
		super(message);
		this.name = 'NetworkError';
	}
}
